import { render } from "./OrchardsList.vue?vue&type=template&id=3e8df061&ts=true"
import script from "./OrchardsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrchardsList.vue?vue&type=script&lang=ts&setup=true"

import "./OrchardsList.vue?vue&type=style&index=0&id=3e8df061&lang=scss"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Company/OrchardsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e8df061"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e8df061', __exports__)) {
    console.log('reload')
    api.reload('3e8df061', __exports__)
  }
  
  module.hot.accept("./OrchardsList.vue?vue&type=template&id=3e8df061&ts=true", () => {
    console.log('re-render')
    api.rerender('3e8df061', render)
  })

}


export default __exports__